<template>
  <img
    :id="id ? `c${id}` : undefined"
    ref="image"
    :class="classes"
    :src="link.url"
    v-bind="$attrs"
    @error="imageLoadingError"
    v-on="$listeners"
  />
</template>

<script>
import { typo3LinkProps } from '@/js/helper/links-helper.js'

export default {
  name: 'BaseImage',
  props: {
    id: {
      type: String,
      default: undefined,
    },
    fallbackImage: {
      type: String,
      default: undefined,
    },
    src: {
      type: [String, Object],
      required: true,
    },
  },
  computed: {
    classes() {
      return [this.$style.image, this.$attrs.class]
    },
    link() {
      return typo3LinkProps(this.src)
    },
  },
  methods: {
    imageLoadingError() {
      if (!this.fallbackImage) {
        return
      }
      this.$refs.image.src = this.fallbackImage
      this.$emit('fallbackimage')
    },
  },
}
</script>

<style lang="scss" module>
.image {
  width: 100%;
  height: auto;
}
</style>
